import { Dialog } from "@mui/material";

import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "@store/store";
import {
    DialogType,
    RejectDialogProps,
    ValidateDialogProps,
    ValidateVisitDialogProps,
    CommentsDialogProps,
    AttribCodeDialogProps,
    NewMajorityShareholder,
    ExternalReviewComments,
    RegistrationInPortfolioErrors,
    EditionBankingInformationDialogProps,
    OfferActionDialogProps,
    ReferenceEditionDialogProps,
    // GuaranteeEditionDialogProps,
    RuleModelEditionDialogProps,
    FinancialRuleModelEditionDialogProps,
    // GuaranteeTypeEditionDialogProps,
    AdditionalAccountDialogProps,
    RevisionCheckPointDialogProps,
} from "@interfaces/slices";

import { Validar } from "./DialogosSegmentos/Validar";

import { Comentarios } from "./DialogosSegmentos/Comentarios";
import { DescargarReporte } from "./DialogosSegmentos/DescargarReporte";
import { RechazarDocumento } from "./DialogosSegmentos/RechazarDocumento";

import { DocumentosFaltantes } from "./DialogosSegmentos/DocumentosFaltantes";
import { DescargarReportePld } from "./DialogosSegmentos/DescargarReportePld";
import { CodigoAtribucion } from "./DialogosSegmentos/CodigoAtribucion";
import { setDialogConfig } from "@store/slices/componentsSlice";
import { NuevoAccionistaMayoritario } from "./DialogosSegmentos/NuevoAccionistaMayoritario";
import { ObservacionesRevisionExterna } from "./DialogosSegmentos/ObservacionesRevisionExterna";
import { ErroresAltaCartera } from "./DialogosSegmentos/ErroresAltaCartera";
import { EdicionInfoBancaria } from "./DialogosSegmentos/EdicionInfoBancaria";
import { Ofertar } from "./DialogosSegmentos/Ofertar";
// import { EdicionEstatus } from "./DialogosSegmentos/EdicionStatus";

import { EdicionReferencia } from "./DialogosSegmentos/EdicionReferencia";

// import { EdicionGarantia } from "./DialogosSegmentos/EdicionGarantia";
import { AltaEdicionReglaModelo } from "./DialogosSegmentos/AltaEdicionReglaModelo";
// import { AltaEdicionReglaModeloFinanciera } from "./DialogosSegmentos/AltaEdicionReglaModeloFinanciera";
// import { EdicionTipoGarantia } from "./DialogosSegmentos/EdicionTipoGarantia";
import { CuentaAdicional } from "./DialogosSegmentos/CuentaAdicional";
import { PuntoRevision } from "./DialogosSegmentos/PuntoRevision";

export const DialogManager = () => {
    const dispatch = useDispatch();

    const dialogConfig = useSelector((state: RootState) => state.components.dialog);

    const dialogs = new Map<DialogType, React.ReactNode>([
        [DialogType.NONE, <></>],
        [
            DialogType.RECHAZAR_DOC,
            <RechazarDocumento
                document={(dialogConfig.props as RejectDialogProps)?.document}
                isProcessing={dialogConfig?.isProcessing ?? false}
                onBackClick={dialogConfig.onRejectClick ?? (() => {})}
                onConfirmClick={dialogConfig.onAcceptClick ?? (() => {})}
            />,
        ],
        [
            DialogType.VALIDAR_DOC,
            <Validar
                type={"VALIDATE_DOC"}
                title={(dialogConfig.props as ValidateDialogProps)?.title}
                isProcessing={dialogConfig?.isProcessing}
                onBackClick={dialogConfig.onRejectClick ?? (() => {})}
                onContinueClick={dialogConfig.onAcceptClick ?? (() => {})}
            />,
        ],
        [
            DialogType.VALIDAR_EXP,
            <Validar
                type={"VALIDATE_EXP"}
                title={(dialogConfig.props as ValidateDialogProps)?.title}
                isProcessing={dialogConfig?.isProcessing}
                onBackClick={dialogConfig.onRejectClick ?? (() => {})}
                onContinueClick={dialogConfig.onAcceptClick ?? (() => {})}
            />,
        ],
        [
            DialogType.VALIDAR_DIC,
            <Validar
                type={"COMPLETE"}
                title={(dialogConfig.props as ValidateDialogProps)?.title}
                isProcessing={dialogConfig?.isProcessing}
                onBackClick={dialogConfig.onRejectClick ?? (() => {})}
                onContinueClick={dialogConfig.onAcceptClick ?? (() => {})}
            />,
        ],
        [
            DialogType.AGENDAR_VISITA,
            <Validar
                type={"VISIT"}
                title={(dialogConfig.props as ValidateDialogProps)?.title}
                date={(dialogConfig.props as ValidateVisitDialogProps)?.date}
                time={(dialogConfig.props as ValidateVisitDialogProps)?.time}
                isProcessing={dialogConfig?.isProcessing}
                onBackClick={dialogConfig.onRejectClick ?? (() => {})}
                onContinueClick={dialogConfig.onAcceptClick ?? (() => {})}
            />,
        ],
        [
            DialogType.BORRAR_DOC,
            <Validar
                type={"DELETE_DOC"}
                title={(dialogConfig.props as ValidateDialogProps)?.title}
                isProcessing={dialogConfig?.isProcessing}
                onBackClick={dialogConfig.onRejectClick ?? (() => {})}
                onContinueClick={dialogConfig.onAcceptClick ?? (() => {})}
            />,
        ],
        [
            DialogType.REGENERAR_DOC,
            <Validar
                type={"REGENERAR_DOC"}
                title={(dialogConfig.props as ValidateDialogProps)?.title}
                isProcessing={dialogConfig?.isProcessing}
                onBackClick={dialogConfig.onRejectClick ?? (() => {})}
                onContinueClick={dialogConfig.onAcceptClick ?? (() => {})}
            />,
        ],

        [
            DialogType.DOCS_FALTANTES,
            <DocumentosFaltantes
                onBackClick={dialogConfig.onRejectClick ?? (() => {})}
                onConfirmClick={dialogConfig.onAcceptClick ?? (() => {})}
            />,
        ],

        [
            DialogType.DESCARGAR_REPORTE,
            <DescargarReporte
            // title={(dialogConfig.props as StatusNotificationDialogProps)?.title}
            // iconType={(dialogConfig.props as StatusNotificationDialogProps)?.iconType}
            // onContinueClick={dialogConfig.onAcceptClick ?? (() => {})}
            />,
        ],
        [
            DialogType.DESCARGAR_REPORTE_PLD,
            <DescargarReportePld
            // title={(dialogConfig.props as StatusNotificationDialogProps)?.title}
            // iconType={(dialogConfig.props as StatusNotificationDialogProps)?.iconType}
            // onContinueClick={dialogConfig.onAcceptClick ?? (() => {})}
            />,
        ],

        [
            DialogType.COMENTARIOS,
            <Comentarios
                title={(dialogConfig.props as CommentsDialogProps)?.title}
                subtitle={(dialogConfig.props as CommentsDialogProps)?.subtitle}
                moduleCode={(dialogConfig.props as CommentsDialogProps)?.moduleCode}
                metadata={(dialogConfig.props as CommentsDialogProps)?.metadata}
                onBackClick={dialogConfig.onRejectClick ?? (() => {})}
                onConfirmClick={dialogConfig.onAcceptClick ?? (() => {})}
            />,
        ],
        [
            DialogType.CODIGOS_ATRIBUCION,
            <CodigoAtribucion
                {...(dialogConfig.props as AttribCodeDialogProps)}
                onBackClick={dialogConfig.onRejectClick ?? (() => dispatch(setDialogConfig()))}
                onConfirmClick={dialogConfig.onAcceptClick ?? (() => {})}
            />,
        ],
        [
            DialogType.NUEVO_ACCIONISTA_MAYORITARIO,
            <NuevoAccionistaMayoritario
                {...(dialogConfig.props as NewMajorityShareholder)}
                onConfirmClick={dialogConfig.onAcceptClick ?? (() => {})}
            />,
        ],
        [
            DialogType.OBSERVACION_REVISION_EXTERNA,
            <ObservacionesRevisionExterna
                {...(dialogConfig.props as ExternalReviewComments)}
                onConfirmClick={dialogConfig.onAcceptClick ?? (() => {})}
                onBackClick={dialogConfig.onRejectClick ?? (() => dispatch(setDialogConfig()))}
            />,
        ],
        [
            DialogType.ERRORES_ALTA_CARTERA,
            <ErroresAltaCartera {...(dialogConfig.props as RegistrationInPortfolioErrors)} />,
        ],
        [
            DialogType.EDICION_INFO_BANCARIA,
            <EdicionInfoBancaria {...(dialogConfig.props as EditionBankingInformationDialogProps)} />,
        ],
        [DialogType.OFERTAR, <Ofertar {...(dialogConfig.props as OfferActionDialogProps)} />],
        // [DialogType.EDICION_ESTATUS, <EdicionEstatus />],
        // [
        //     DialogType.EDICION_REFERENCIA,
        //     <EdicionReferencia
        //         {...(dialogConfig.props as ReferenceEditionDialogProps)}
        //         onAcceptClick={dialogConfig.onAcceptClick ?? (() => {})}
        //     />,
        // ],
        // [
        // DialogType.EDICION_GARANTIA_VEHICULAR,
        //     <EdicionGarantia {...(dialogConfig.props as GuaranteeEditionDialogProps)} />,
        // ],
        [
            DialogType.ALTA_EDICION_REGLAS_MODELO,
            <AltaEdicionReglaModelo {...(dialogConfig.props as RuleModelEditionDialogProps)} />,
        ],
        // [
        //     DialogType.ALTA_EDICION_REGLAS_MODELO_FINANCIERA,
        //     <AltaEdicionReglaModeloFinanciera {...(dialogConfig.props as FinancialRuleModelEditionDialogProps)} />,
        // ],
        // [
        //     DialogType.EDICION_TIPO_GARANTIA,
        //     <EdicionTipoGarantia {...(dialogConfig.props as GuaranteeTypeEditionDialogProps)} />,
        // ],
        [DialogType.CUENTA_ADICIONAL, <CuentaAdicional {...(dialogConfig.props as AdditionalAccountDialogProps)} />],
        [DialogType.REVISION_CHECKPOINT, <PuntoRevision {...(dialogConfig.props as RevisionCheckPointDialogProps)} />],
    ]);

    return (
        <Dialog
            open={dialogConfig.shown}
            fullScreen={dialogConfig.fullscreen}
            maxWidth={dialogConfig.maxWidth}
            fullWidth={dialogConfig.fullWidth}
        >
            {dialogs.get(dialogConfig.type)}
        </Dialog>
    );
};
